import axiosInstance from "./baseUrl";

export type PaymentOptionStatus = "ACTIVE" | "INACTIVE";

export const getAdminPaymentOptions = async () => {
  const response = await axiosInstance.get(
    "/v1/paymentOption/admin/list_bank_providers"
  );
  return response.data;
};

export const togglePaymentOptionStatus = async (
  id: string,
  status: PaymentOptionStatus
) => {
  const response = await axiosInstance.post(
    `/v1/paymentOption/admin/${id}/toggle-status`,
    { status }
  );
  return response.data;
};
